import { StateModel } from "./state.model";


export class CityModel {
    id!: number;
    cityE!: string;
    cityY!: string;
    cityMN!: string;
    stateId!: number;
    state: StateModel;

    constructor() {
        this.state = new StateModel();
    }

}